import React from 'react';
import './RatesDirectionsCSS.css';
import CollapsibleTable from '../../../common/collapsibletable/CollapsibleTable';
import Card from "../../../common/card/card";
import {createElementFromHTML} from '../../../../helpers/helpers'
import {getListItem} from '../../../../helpers/helpers'

export default class RatesDirectionsComponent extends React.Component {
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0,4) === '/es' || window.location.pathname.slice(0,4) === '/es/';
        this.state = {comps: [],isSpanish};
        this.getData();
    }

    getData = () => {
        getListItem('2cb2fea0-0c49-6a75-a385-ff1400f4265d', this.state.isSpanish)
            .then(resp => {
                resp.elements = resp.value.map(item => createElementFromHTML(item.Content));
                return resp;
            }).then(resp => {
            let content = [];
            let headers = [];
            let titles = [];
            let comps = [];
            for (let elem = 0; elem < resp.elements.length; elem++) {
                let item = resp.elements[elem];
                titles.push(resp.value[elem].Title);

                if (item[0].nodeName.toUpperCase() === 'TABLE') {
                    item = item[0];
                    for (let fidx = 0; fidx < item.children.length; fidx++) {
                        let tempContent = [];
                        if (item.children[fidx].nodeName.toUpperCase() === 'TBODY') {
                            let tbody = item.children[fidx];
                            for (let idx = 0; idx < tbody.children.length; idx++) {
                                let cells = tbody.children[idx].cells;
                                if (idx === 0) {
                                    let tempHeaders = [];
                                    for (let i = 0; i < cells.length; i++) {
                                        tempHeaders.push(cells[i].innerHTML);
                                    }
                                    headers.push(tempHeaders);
                                    continue;
                                }
                                let temp = [];

                                for (let i = 0; i < cells.length; i++) {
                                    temp.push(cells[i].innerHTML);
                                }
                                tempContent.push(temp);
                            }


                            comps.push(<CollapsibleTable open={false} key={resp.value[elem].Title} className={elem === 0 ? "col-12 px-2 col-md-7 pt-0" : "col-12 p-2"}
                                                         heading={headers[elem]}
                                                         rows={tempContent}
                                                         title={resp.value[elem].Title}/>)
                        }

                    }

                } else if(item[0].nodeName.toUpperCase() === 'IMG') {
                    headers.push([]);
                    comps.push(
                        <div className={"col-12 col-md-7 mt-2"} key={resp.value[elem].Title}>
                            <div className="col-12 prepaid-heading p-2">{resp.value[elem].Title}</div>
                            <img src={item[0].src} className={"img-fluid p-3"}/>
                        </div>
                    )
                }else {
                    headers.push([]);

                    let p = [];
                    item.forEach(item => {
                        p.push(item.innerHTML)
                    });

                    comps.push(<Card collapsable={false} open={true} title={resp.value[elem].Title} className={elem === 1 ? "col-12 col-md-5" : "col-12 col-md-5 mt-2"} key={resp.value[elem].Title}>
                        {p.map((i, idx) => <p key={idx} dangerouslySetInnerHTML={{__html: i}}/> )}
                    </Card>)
                }
            }

            this.setState(Object.assign(this.state, {rows: content}, {titles}, {headers: headers}, {comps}))

        }).catch(e => console.log(e));
    };

    render() {
        return (
            <div>
                <div className="row mt-0">
                {this.state.comps.map((item, idx) => item)}
                </div>
            </div>
        )
    }
}
